import axios from "axios";
import Utility from "../utility/Utility";
import AuthService from "./AuthService";

let _singleton = true;
let _instance: any;

class HttpService {
  constructor() {
    if (_singleton) {
      throw new SyntaxError("This is singleton class");
    }
  }

  static get instance() {
    if (!_instance) {
      _singleton = false;
      _instance = new HttpService();
      _singleton = true;
    }
    return _instance;
  }

  async callFhir(url: string, method: string) {
    const headers = {
      "content-Type": "application/json",
      authorization: AuthService.instance.authToken,
    };

    try {
      const response = await axios.request({ url, method, headers });
      if (response.status !== 200) {
        this.showError(response);
      }
      return response.data;
    } catch (error) {
      //console.log("Error: ", error);
    }
  }

  async callLaunchTokenAPI(url: string, method: string, data: any) {
    const headers = {
      "content-Type": "application/x-www-form-urlencoded",
    };

    url = Utility.env?.REACT_APP_API_BASE_URL + url;
    //console.log(method, url);
    try {
      const inrospectUrl =
        process.env.REACT_APP_PCPO_BACK_END_HEALTH_API + "/introspect";
      const authToken = { token: AuthService.instance.rawAuthToken };
      const introspectToken = await this.callIntrospect(
        inrospectUrl,
        "POST",
        authToken
      );
      if (introspectToken.active === true) {
        const response = await axios.request({ url, method, headers, data });
        if (response.status !== 200) {
          this.showError(response);
        }
        return response.data;
      } else {
        throw {
          status: 400,
          statusCode: "introspectCheck",
          message: "introspect is active",
        };
      }
    } catch (error: any) {
      throw error;
    }
  }

  async callAPI(url: string, method: string, data: any, callType?: string) {
    const headers = {
      "content-Type": "application/json",
      authorization: AuthService.instance.authToken,
    };

    switch (callType) {
      case "auth0":
        url = Utility.env?.REACT_APP_PCPO_BACK_END_API + url;
        break;
      default:
        url = Utility.env?.REACT_APP_API_BASE_URL + url;
        break;
    }

    try {
      const inrospectUrl =
        process.env.REACT_APP_PCPO_BACK_END_HEALTH_API + "/introspect";
      const authToken = { token: AuthService.instance.rawAuthToken };
      const introspectToken = await this.callIntrospect(
        inrospectUrl,
        "POST",
        authToken
      );

      if (introspectToken.active === true) {
        const response = await axios.request({ url, method, headers, data });
        if (response.status !== 200) {
          this.showError(response);
        }
        return response.data;
      } else {
        throw {
          status: 400,
          statusCode: "introspectCheck",
          message: "introspect is active",
        };
      }
    } catch (error) {
      throw error;
    }
  }

  async callStaticResource(url: string) {
    const headers = {
      "content-Type": "text/plain",
    };
    const method = "GET";

    // console.log(method, url);
    try {
      const inrospectUrl =
        process.env.REACT_APP_PCPO_BACK_END_HEALTH_API + "/introspect";
      const authToken = { token: AuthService.instance.rawAuthToken };
      const introspectToken = await this.callIntrospect(
        inrospectUrl,
        "POST",
        authToken
      );
      if (introspectToken.active === true) {
        const response = await axios.request({ url, method, headers });
        if (response.status !== 200) {
          this.showError(response);
        }
        return response.data;
      } else {
        throw {
          status: 400,
          statusCode: "introspectCheck",
          message: "introspect is active",
        };
      }
    } catch (error: any) {
      throw error;
    }
  }

  async callPcpoKeycloakAPI(url: string, method: any) {
    // This api does not generate access token any more.
    try {
      const response = await axios.post(url, method);
      if (response.status !== 200) {
        this.showError(response);
      }
      return response;
    } catch (error) {
      //console.log("Error: ", error);
    }
  }

  async callPcpoCdr(url: string) {
    // This api does not need the access token any more.
    try {
      const response = await axios.get(url);
      if (response.status !== 200) {
        this.showError(response);
      }
      return response;
    } catch (error) {
      //console.log("Error: ", error);
      throw error;
    }
  }

  async callCdr(_url: string, method: string, data?: any) {
    const url: string = process.env.REACT_APP_FHIR_BASE_URL + _url;
    const headers = {
      "content-Type": "application/json",
      authorization: AuthService.instance.authToken,
    };
    try {
      const response = await axios.request({ url, method, headers, data });
      return response;
    } catch (error) {
      return error;
    }
  }

  async callBackEndApi(url: string, method: any) {
    try {
      const response = await axios.get(url, method);
      if (response.status !== 200) {
        this.showError(response);
      }
      return response;
    } catch (error) {
      //console.log("Error: ", error);
    }
  }
  showError(resp: any) {
    //console.log("Error");
  }

  async callBulkAPI(url: string, method: any, data: any) {
    const headers = {
      "content-type": "multipart/form-data",
      authorization: AuthService.instance.authToken,
    };
    url = Utility.env?.REACT_APP_PCPO_BACK_END_API + url;
    try {
      const inrospectUrl =
        process.env.REACT_APP_PCPO_BACK_END_HEALTH_API + "/introspect";
      const authToken = { token: AuthService.instance.rawAuthToken };
      const introspectToken = await this.callIntrospect(
        inrospectUrl,
        "POST",
        authToken
      );
      if (introspectToken.active === true) {
        const response = await axios.request({ url, method, headers, data });
        if (response.status !== 200) {
          this.showError(response);
        }
        return response.data;
      } else {
        throw {
          status: 400,
          statusCode: "introspectCheck",
          message: "introspect is active",
        };
      }
    } catch (error) {
      throw error;
    }
  }

  async callBulkSMS(url: string, method: any, data: any) {
    const headers = {
      "content-type": "application/json",
      authorization: AuthService.instance.authToken,
    };
    url = Utility.env?.REACT_APP_PCPO_BACK_END_API + url;
    try {
      const inrospectUrl =
        process.env.REACT_APP_PCPO_BACK_END_HEALTH_API + "/introspect";
      const authToken = { token: AuthService.instance.rawAuthToken };
      const introspectToken = await this.callIntrospect(
        inrospectUrl,
        "POST",
        authToken
      );
      if (introspectToken.active === true) {
        const response = await axios.request({ url, method, headers, data });
        if (response.status !== 200) {
          this.showError(response);
        }
        return response.data;
      } else {
        throw {
          status: 400,
          statusCode: "introspectCheck",
          message: "introspect is active",
        };
      }
    } catch (error) {
      throw error;
    }
  }

  async callIntrospect(url: string, method: string, data: any) {
    try {
      const response = await axios.request({ url, method, data });
      if (response.status !== 200) {
        this.showError(response);
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
export default HttpService;
